// Third party
import { PayloadAction } from '@reduxjs/toolkit';

// Components
import { IRootState } from './type';
import { initialState } from './slice';

const reducers = {
  setBillingReport: (state: IRootState, action: PayloadAction<IRootState['billing_report']>) => ({
    ...state,
    billing_report: action.payload,
  }),
  resetBillingReport: () => initialState,
};

export { reducers };
